import { motion, AnimatePresence } from "framer-motion";
import "../styles/ContactPopup.css";
import ContactFormContainer from "./ContactFormContainer";

export default function ContactPopup({ open, onClose, formType = "serene" }) {
  const overlayVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.22 } },
    exit: { opacity: 0, transition: { duration: 0.18 } },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 80, scale: 0.96 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] },
    },
    exit: {
      opacity: 0,
      y: 60,
      scale: 0.96,
      transition: { duration: 0.2 },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.45, ease: "easeOut" },
    },
  };

  const wordContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.04,
        delayChildren: 0.06,
      },
    },
  };

  const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="contact-popup-overlay"
          variants={overlayVariants}
          initial="hidden"
          animate="show"
          exit="exit"
        >
          <motion.div
            className="contact-popup-card m-0 text-white rounded-3 p-4 p-md-5"
            variants={cardVariants}
            initial="hidden"
            animate="show"
            exit="exit"
          >
            <button type="button" className="popup-close" onClick={onClose}>
              &times;
            </button>

            <ContactFormContainer
              variant={formType}
              fadeUp={fadeUp}
              wordContainer={wordContainer}
              wordVariant={wordVariant}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

